import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import { SORT_DIRECTION_KEY, SORT_FIELD_KEY } from 'src/utils/constants';

export const parseSort = (searchParams) => {
	const field = searchParams.get(SORT_FIELD_KEY);
	const direction = searchParams.get(SORT_DIRECTION_KEY);

	if (!field || !direction) {
		return undefined;
	}

	return [{ field, direction }];
};

const setSortParams = (searchParams, setSearchParams, field, direction) => {
	const params = new URLSearchParams(searchParams);

	params.set(SORT_FIELD_KEY, field);
	params.set(SORT_DIRECTION_KEY, direction);
	params.set('page', '1');

	setSearchParams(params);
};

const removeSortParams = (searchParams, setSearchParams) => {
	const params = new URLSearchParams(searchParams);

	params.delete(SORT_FIELD_KEY);
	params.delete(SORT_DIRECTION_KEY);

	setSearchParams(params);
};

export const useSort = () => {
	const [searchParams, setSearchParams] = useSearchParams();

	const getSort = useCallback(() => {
		const field = searchParams.get(SORT_FIELD_KEY);
		const direction = searchParams.get(SORT_DIRECTION_KEY);

		if (!field || !direction) {
			return null;
		}

		return { field, direction };
	}, [searchParams]);

	return {
		setSort: (field, direction) =>
			setSortParams(searchParams, setSearchParams, field, direction),
		removeSort: () => removeSortParams(searchParams, setSearchParams),
		getSort,
		parseSort: () => parseSort(searchParams),
	};
};
